import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

import api from './api'
import map from './map'
import structure from './structure'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules:{
      api,
      map,
      structure
    },
    state: {
      abc: 10,
      companyUnits: 0,
      tokenService: null,
      controlsNeedRefresh: [],
      colors: {
        coldWaterMeters: ['#005AB5', '#0066CC', '#0072E3', '#0080FF', '#2894FF', '#46A3FF', '#66B3FF', '#84C1FF', '#97CBFF', '#A9DAFF'],
        hotWaterMeters: ['#AE0000', '#CE0000', '#EA0000', '#FF0000', '#FF2D2D', '#FF5151', '#FF7575', '#FF9797', '#FFB5B5', '#FFD2D2'],
        gasMeters: ['#DF0050', '#BF0060', '#D9006C', '#F00078', '#FF0080', '#FF359A', '#FF60AF', '#FF79BC', '#FF95CA', '#FFAAD5'],
        heatMeters: ['#FDD835', '#FDD855', '#FDD875', '#FDD895', '#FDD8A5', '#FDD8C5', '#FFE4B5', '#FFDAB9', '#EEE8AA', '#F0E68C'],
        electricityMeters: ['#007979', '#009393', '#00AEAE', '#00CACA', '#00E3E3', '#00FFFF', '#4DFFFF', '#80FFFF', '#A6FFFF', '#BBFFFF'],
      },
      userSettings: {
        showTooltips: false,
        countFixedDigits: 3
      },
    },
    getters,
    mutations,
    actions
  })
